module.exports = __webpack_public_path__ + "static/media/FTM.4e7e713e.svg";